import React from "react";
import { v4 } from "uuid";
import { IEntity, IWaveActor } from "../../../store/types";
import { Button } from "../Common";
import { FirebaseContainer, useStoreAdders } from "../FirebaseProvider";
import { FirebaseUploaderProps, WaveUploaderProps } from "../types";

// separate component since useStoreAdders needs to be inside a FirebaseContainer
export const FirebaseUploader = (props: FirebaseUploaderProps) => {
  const { wave, onFinish } = props;
  const { addData } = useStoreAdders();
  return <Button onClick={() => addData(wave).then(onFinish)} label="Upload" />;
};

export function getWaveActors(stateActors: IEntity[]): IWaveActor[] {
  const actors: IWaveActor[] = stateActors.map(actor => ({
    actor,
    battleDuration: 15,
    text: []
  }));
  return actors;
}

export function WaveUploader(props: WaveUploaderProps) {
  const { onFinish, actors, waveName } = props;
  const wave = { name: waveName, actors: getWaveActors(actors), id: v4() };

  return (
    <div id="wave-uploader">
      <FirebaseContainer>
        <FirebaseUploader wave={wave} onFinish={onFinish} />
      </FirebaseContainer>
      <button type="button" className="nes-btn" onClick={onFinish}>
        Cancel
      </button>
    </div>
  );
}
